var currScrollHeight = 0;
var MESSAGE_TEXT_HEIGHT = 27;


var sbNickname = null;
var sbUserId = null;
var channelListPage = 0;
var currChannelUrl = null;
var currChannelInfo = null;
var leaveChannelUrl = '';
var leaveMessagingChannelUrl = '';
var hideChannelUrl = '';
var sbUserListToken = '';
// var targetAddGroupChannel = null;
var sbWithChannelList = true;

var isOpenChat = false;
var memberList = [];

var channelType = 'group_channels';

var meetingStart = '';
var meetingEnd = '';
var inMeetingTime = false;

var PreviousMessageListQuery = null;

// 3.0.x
var currentUser;

var sbOpenChannelListQuery;

// custom
/// 검색된 이름
var sbSearchName = '';
var sbSearchUsersNextToken = '';
var sbSearchChannelsNextToken = '';
var sbSearchChannlesFrom;
var sbSearchChannlesTo;
/**
 * 현재 대화중인 사용자 id 리스트
 */
var sbCurrentTargetUserIds;

const sbMessagingStartBt = $('#btn_messaging_chat');
const sbMessagingInputField = $('.chat-input-text__field');
const sbFileInputField = $('#chat_file_input');
const sbMessageSendButton = $('.sendbirdMessageSendBtn');
const sbCurrentUsersButton = $('.chat-top__button-member');
// const sbOpenMessagingStartBt = $('#btn_open_chat');
// const sbOpenChannel = $('.left-nav-channel-open');

// $('#guide_create').click(function () {
//   $('.modal-guide-create').hide();
// });

function xssEscape(target) {
  if (typeof target === 'string') {
    return target
      .split('&').join('&amp;')
      .split('#').join('&#35;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split('\'').join('&apos;')
      .split('+').join('&#43;')
      .split('-').join('&#45;')
      .split('(').join('&#40;')
      .split(')').join('&#41;')
      .split('%').join('&#37;');
  } else {
    return target;
  }
}

/***********************************************
 *                OPEN CHAT
 **********************************************/
// sbOpenMessagingStartBt.click(function () {
//   popupInit();
//   $('.modal-guide-create').hide();
//   $('.left-nav-button-guide').hide();
//   $('.modal-messaging').hide();
//   sbMessagingStartBt.removeClass('left-nav-messaging--active');
//
//   if ($(this).hasClass('left-nav-open--active')) {
//     $('.right-section__modal-bg').hide();
//     $(this).removeClass('left-nav-open--active');
//     $('.modal-open-chat').hide();
//   } else {
//     $('.right-section__modal-bg').show();
//     $(this).addClass('left-nav-open--active');
//     sbGetOpenChannelList(true);
//   }
// });
//
// $('.modal-open-chat-more').click(function () {
//   sbGetOpenChannelList(false);
// });
//
// // Create OpenChannel
// $('#btn_create_open_channel').click(function () {
//   sbModalInput("Create Open Channel", "", function (channelName) {
//     sb.OpenChannel.createChannel(channelName, '', '', function (channel, error) {
//       sbJoinOpenChannel(channel.url);
//     });
//   });
// });

// $(document).on('click', '.chat-canvas__list-name', function (e) {
//   var userId = $(this).data('userid');
//   if (isCurrentUser(userId)) {
//     console.log('can not block, current user');
//     return;
//   }

//   sb_showComfirmModal('Are you Sure?', 'Do you want to block this user?', function () {
//     sb.blockUserWithUserId(userId, function (response, error) {
//       console.log(response, error);
//     });
//   });
// });

// 삭제하기?? 는 기능 추가 안함.
// $(document).on('click', '.chat-canvas__list-text', function (e) {
//   var userId = $(this).prev().prev().data('userid');
//   var messageId = $(this).data('messageid');
//   var channelUrl = currChannelInfo.url;
//   var messageObject = $(this);

//   sb_showComfirmModal('Are you Sure?', 'Do you want to delete message?', function () {
//     currChannelInfo.deleteMessage(channelMessageList[channelUrl][messageId]['message'], function (response, error) {
//       if (!error) {
//         delete(channelMessageList[channelUrl][messageId]);
//         messageObject.parent().remove();
//       }
//     });
//   });
// });

// 모달
// function sbShowConfirmModal(title, desc, submit, close) {
//   $('.modal-confirm-title').html(title);
//   $('.modal-confirm-desc').html(desc);
//
//   $('.modal-confirm-close').click(function () {
//     if (close) {
//       close();
//     }
//     $('.modal-confirm').hide();
//     $('.modal-confirm-close').unbind('click');
//   });
//
//   $('.modal-confirm-submit').click(function () {
//     if (submit) {
//       submit();
//     }
//     $('.modal-confirm').hide();
//     $('.modal-confirm-submit').unbind('click');
//   });
//
//   $('.modal-confirm').show();
// }

// function sbModalInput(title, desc, submit, close) {
//   $('.modal-input-title').html(title);
//   $('.modal-input-desc').html(desc);
//
//   // $('.modal-confirm-submit').unbind('click');
//   // $('.modal-confirm-close').unbind('click');
//
//   $('.modal-input-box-elem').keydown(function (e) {
//     var keyCode = e.which;
//     switch (keyCode) {
//       case 13: // enter
//         if (submit) {
//           submit($('.modal-input-box-elem').val());
//         }
//         $('.modal-input').hide();
//         $('.modal-input-close').unbind('click');
//         $('.modal-input-box-elem').unbind('keydown');
//         break;
//       case 27: // esc
//         if (close) {
//           close();
//         }
//         $('.modal-input').hide();
//         $('.modal-input-close').unbind('click');
//         $('.modal-input-box-elem').unbind('keydown');
//         break;
//     }
//   });
//
//   $('.modal-input-close').click(function () {
//     if (close) {
//       close();
//     }
//     $('.modal-input').hide();
//     $('.modal-input-close').unbind('click');
//   });
//
//   $('.modal-input-submit').click(function () {
//     if (submit) {
//       submit($('.modal-input-box-elem').val());
//     }
//     $('.modal-input').hide();
//     $('.modal-input-submit').unbind('click');
//   });
//
//   $('.modal-input').show(0, function () {
//     $('.modal-input-box-elem').focus();
//   });
// }


// function sbGetOpenChannelList(isFirstPage) {
//   if (isFirstPage) {
//     $('.modal-open-chat-list').html('');
//     sbOpenChannelListQuery = sb.OpenChannel.createOpenChannelListQuery();
//   }
//
//   if (sbOpenChannelListQuery.hasNext) {
//     sbOpenChannelListQuery.next(function (channels, error) {
//       if (error) {
//         return;
//       }
//
//       $('.modal-open-chat-list').append(sbCreateOpenChannelList(channels));
//       channelListPage = channels['page'];
//       if (channels['next'] != 0) {
//         $('.modal-open-chat-more').show();
//       } else {
//         $('.modal-open-chat-more').hide();
//       }
//       $('.modal-open-chat').show();
//     });
//   }
// }
//
// function sbCreateOpenChannelList(channels) {
//   var channelListHtml = '';
//
//   for (var i in channels) {
//     var channel = channels[i];
//     var item = '<div class="modal-open-chat-list__item" onclick="sbJoinOpenChannel(\'%channelUrl%\')">%channelImage% &nbsp;%channelName%</div>';
//     item = item.replace(/%channelUrl%/, channel.url).replace(/%channelName%/, xssEscape(channel.name));
//     item = item.replace(/%channelImage%/, '<img src="' + channel.coverUrl + '" /> ');
//
//     channelListHtml += item;
//   }
//   return channelListHtml;
// }

// function sbJoinOpenChannel(channelUrl) {
//   if (channelUrl == currChannelUrl) {
//     navInit();
//     popupInit();
//     return false;
//   }
//
//   PreviousMessageListQuery = null;
//   sb.OpenChannel.getChannel(channelUrl, function (channel, error) {
//     if (error) {
//       return;
//     }
//
//     channel.enter(function (response, error) {
//       if (error) {
//         if (error.code == 900100) {
//           alert('Oops...You got banned out from this channel.');
//         }
//         return;
//       }
//
//       $('.chat-top__button-hide').hide();
//
//       currChannelInfo = channel;
//       currChannelUrl = channelUrl;
//
//       $('.chat-empty').hide();
//       initChatTitle(xssEscape(currChannelInfo.name), 0);
//
//       $('.chat-canvas').html('');
//       sbMessagingInputField.val('');
//       $('.chat').show();
//
//       navInit();
//       popupInit();
//
//       isOpenChat = true;
//       loadMoreChatMessage(scrollPositionBottom);
//       setWelcomeMessage(xssEscape(currChannelInfo.name));
//       sbAddOpenChannel();
//       sbMessagingInputField.attr('disabled', false);
//
//     });
//   });
// }
//
// function sbAddOpenChannel() {
//   if (sbOpenChannel.length == 0) {
//     $('.left-nav-channel-empty').hide();
//   }
//
//   $.each($('.left-nav-channel'), function (index, channel) {
//     $(channel).removeClass('left-nav-channel-open--active');
//     $(channel).removeClass('left-nav-channel-messaging--active');
//     $(channel).removeClass('left-nav-channel-group--active');
//   });
//
//   let addFlag = true;
//   $.each(sbOpenChannel, function (index, channel) {
//     if (currChannelUrl == $(channel).data('channel-url')) {
//       $(channel).addClass('left-nav-channel-open--active');
//       addFlag = false;
//     }
//   });
//
//   if (addFlag) {
//     $('#open_channel_list').append(
//       '<div class="left-nav-channel left-nav-channel-open left-nav-channel-open--active" ' +
//       '     onclick="sbJoinOpenChannel(\'' + currChannelInfo.url + '\')"' +
//       '     data-channel-url="' + currChannelInfo.url + '"' +
//       '>' +
//       (currChannelInfo.name.length > 12 ? xssEscape(currChannelInfo.name.substring(0, 12)) + '...' : xssEscape(currChannelInfo["name"])) +
//       '</div>'
//     );
//   }
//
//   $('.modal-guide-create').hide();
//   $('.left-nav-button-guide').hide();
// }

function leaveChannel(channel, obj) {
  popupInit();
  
  leaveChannelUrl = channel['channel_url'];
  
  if ($('.chat-top__button-invite').is(':visible')) {
    $('.modal-leave-channel-desc').html('Do you want to leave this messaging channel?');
  } else {
    $('.modal-leave-channel-desc').html('Do you want to leave this channel?');
  }
  
  $('.modal-leave-channel').show();
  return false;
}

$('.chat-top__button-leave').click(function () {
  if ($('.chat-top__button-invite').is(':visible')) {
    endMessaging(currChannelInfo, $(this))
  } else {
    leaveChannel(currChannelInfo, $(this));
  }
});

$('.chat-top__button-hide').click(function () {
  if (currChannelInfo.isOpenChannel()) {
    return;
  }
  
  hideChannel(currChannelInfo);
});

sbCurrentUsersButton.click(function () {
  if ($('.modal-member').is(":visible")) {
    $(this).removeClass('chat-top__button-member--active');
    $('.modal-member').hide();
  } else {
    popupInit();
    $(this).addClass('chat-top__button-member--active');
    getMemberList(currChannelInfo);
    $('.modal-member').show();
  }
});

$('.chat-top__button-invite').click(function () {
  if ($('.modal-invite').is(":visible")) {
    $(this).removeClass('chat-top__button-invite--active');
    $('.modal-invite').hide();
  } else {
    popupInit();
    $(this).addClass('chat-top__button-invite--active');
    sbGetUserList();
    $('.modal-invite').show();
  }
});

function getMemberList(channel) {
  console.log('getmemberlist');
  if (channel.isOpenChannel()) {
    let openChannelParticipantListQuery = channel.createParticipantListQuery(channel);
    openChannelParticipantListQuery.next(function (members, error) {
      if (error) {
        return;
      }
      
      $('.modal-member-list').html('');
      var memberListHtml = '';
      members.forEach(function (member) {
        memberListHtml += '' +
          '<div class="modal-member-list__item">' +
          '<div class="modal-member-list__icon modal-member-list__icon--online"></div>' +
          '  <div class="modal-member-list__name">' +
          (member.nickname.length > 13 ? xssEscape(member.nickname.substring(0, 12)) + '...' : xssEscape(member.nickname)) +
          '  </div>' +
          '</div>';
      });
      $('.modal-member-list').html(memberListHtml);
    });
  }
  
  if (channel.isGroupChannel()) {
    var members = channel.members;
    $('.modal-member-list').html('');
    
    var memberListHtml = '';
    members.forEach(function (member) {
      if (member.connectionStatus == 'online') {
        var isOnline = 'online';
        var dateTimeString = '';
      } else {
        var isOnline = '';
        var dateTime = new Date(member.lastSeenAt);
        var dateTimeString = (dateTime.getMonth() + 1) + '/' + dateTime.getDate() + ' ' + dateTime.getHours() + ':' + dateTime.getMinutes();
      }
      
      
      memberListHtml += '' +
        '<div class="modal-member-list__item">' +
        '<div class="modal-member-list__icon"><img src="' + member.profileUrl + '" /></div>' +
        '  <div class="modal-member-list__name ' + isOnline + '">' +
        (member.nickname.length > 13 ? xssEscape(member.nickname.substring(0, 12)) + '...' : xssEscape(member.nickname)) +
        '  </div>' +
        '<div class="modal-member-list__lastseenat">' + dateTimeString + '</div>' +
        '</div>';
    });
    $('.modal-member-list').html(memberListHtml);
  }
}

$('.modal-leave-channel-close').click(function () {
  $('.modal-leave-channel').hide();
  leaveChannelUrl = '';
  return false;
});

$('.modal-leave-channel-submit').click(function () {
  $('#open_channel_list').removeClass('chat-top__button-leave--active');
  
  leaveCurrChannel();
});

$('.modal-hide-channel-close').click(function () {
  $('.modal-hide-channel').hide();
  leaveChannelUrl = '';
  return false;
});

$('.modal-hide-channel-submit').click(function () {
  // $('#open_channel_list').removeClass('chat-top__button-leave--active');
  // leaveCurrChannel();
  hideCurrChannel();
});
/***********************************************
 *              // END OPEN CHAT
 **********************************************/


/***********************************************
 *                MESSAGING
 **********************************************/

sbMessagingStartBt.click(function () {
  popupInit();
  // $('.modal-guide-create').hide();
  $('.left-nav-button-guide').hide();
  // $('.modal-open-chat').hide();
  // sbOpenMessagingStartBt.removeClass('left-nav-open--active');
  
  if ($(this).hasClass('left-nav-messaging--active')) {
    $('.right-section__modal-bg').hide();
    $(this).removeClass('left-nav-messaging--active');
    $('.modal-messaging').hide();
  } else {
    $('.right-section__modal-bg').show();
    $(this).addClass('left-nav-messaging--active');
    sbUserListToken = '';
    $('.modal-messaging-list').html('');
    $('input[name="searchName"]').val('');
    $('#searchNameClearBt').hide();
    sbGetUserList(true);
    $('.modal-messaging').show();
  }
});

/**
 * 사용자 조회
 * @param {boolean?} isFirstPage
 * @param {string?} searchName
 */
function sbGetUserList(isFirstPage, searchName) {
  console.log("load users isFirst=" + isFirstPage);
  if (isFirstPage) {
    sbSearchName = searchName; // 1페이지 로딩시 검색어 저장
    $('.modal-messaging-list').html('');
    if (searchName && !searchName.isBlank()) {
      console.log("load users searchName=" + searchName);
      sbUserListQuery = null;
      ApiSb.searchUsers(searchName, sbSearchUsersNextToken).then(function (res) {
        sbSearchUsersNextToken = res.next;
        handleUsers(res.users, null);
      }).catch(function (err) {
        sbSearchUsersNextToken = '';
        handleUsers([], err);
      });
    } else {
      sbSearchUsersNextToken = '';
      sbUserListQuery = sb.createUserListQuery();
      sbUserListQuery.limit = 100;
    }
  }
  
  let moreBt = $('.modal-messaging-more');
  let handleUsers = function (userList, error) {
    moreBt.remove();
    if (error) {
      console.log(error.message);
      return;
    }
    
    $.each(userList, function (index, user) {
      if (user.nickname.length) {
        let userId = user.userId ? user.userId : user.user_id;
        sbUserList[userId] = user;
        if (!sbu.isCurrentUser(userId)) {
          $('.modal-messaging-list').append(
            '<div class="modal-messaging-list__item" onclick="sbOnUserItemClick($(this))">' +
            (user.nickname.length > 12 ? xssEscape(user.nickname.substring(0, 12)) + '...' : xssEscape(user.nickname)) +
            ' (' + userId + ')' +
            '  <div class="modal-messaging-list__icon" data-guest-id="' + userId + '"></div>' +
            '</div>'
          );
        }
      }
    });
    
    if (sbHasNextUserListPage()) {
      $('.modal-messaging-list').append(
        '<div class="modal-messaging-more" onclick="sbGetUserListMore()">MORE<div class="modal-messaging-more__icon"></div></div>'
      );
    }
  };
  
  if (sbUserListQuery) {
    sbUserListQuery.next(handleUsers);
  }
}

/**
 * 사용자 조회에 다음 페이지가 있는지 여부
 * @returns {boolean}
 */
function sbHasNextUserListPage() {
  return sbSearchUsersNextToken || (sbUserListQuery && sbUserListQuery.hasNext)
}

/**
 * 사용자 조회의 다음 페이지 로딩
 */
function sbGetUserListMore() {
  sbGetUserList(false, sbSearchName);
}

function sbOnUserItemClick(obj) {
  let el = obj.find('div');
  if (el.hasClass('modal-messaging-list__icon--select')) {
    el.removeClass('modal-messaging-list__icon--select');
  } else {
    el.addClass('modal-messaging-list__icon--select');
  }
  
  let selectCount = $('.modal-messaging-list__icon--select').length;
  if (selectCount > 1) {
    $('.modal-messaging-top__title').html('Group Chat ({})'.format(selectCount));
  } else {
    $('.modal-messaging-top__title').html('Group Channel');
  }
}

function sbStartMessaging() {
  if ($('.modal-messaging-list__icon--select').length == 0) {
    admin_showConfirmModal(null, '회원을 선택해주세요');
    return false;
  }
  
  let startMessagingProcess = function () {
    let userIds = [];
    $.each($('.modal-messaging-list__icon--select'), function (index, user) {
      let u = sbUserList[$(user).data("guest-id")];
      userIds.push(u.userId ? u.userId : u.user_id);
    });
    PreviousMessageListQuery = null;
    // console.log(userIds);
    if (userIds.length <= 0) {
      admin_showConfirmModal(null, "선택된 회원이 없습니다.");
      return;
    }
    
    let myId = currentUser.userId;
    userIds.push(myId);
    console.log(userIds.join('_'));
    // userIds, IS_DISTINCT, NAME, COVER_IMAGE_OR_URL, DATA, CUSTOM_TYPE, function(groupChannel, error)
    // https://sendbird.com/docs/chat/v3/javascript/guides/group-channel#2-create-a-channel
    sb.GroupChannel.createChannelWithUserIds(userIds, true, userIds.join('_'), '', '', function (channel, error) {
      if (error) {
        console.log(error);
        return;
      }
      
      currChannelInfo = channel;
      currChannelUrl = channel.url;
      
      var members = channel.members;
      var channelTitle = '';
      
      sbCurrentTargetUserIds = [];
      $.each(members, function (index, member) {
        if (!sbu.isCurrentUser(member.userId)) {
          sbCurrentTargetUserIds.push(member.userId);
          channelTitle += xssEscape(member.nickname) + ', ';
        }
      });
      
      channelTitle = channelTitle.slice(0, -2);
      const channelMemberList = channelTitle;
      if (channelTitle.length > 20) {
        channelTitle = channelTitle.substring(0, 20);
        channelTitle += '...'
      }
      let titleType = 1;
      if (members.length > 2) {
        channelTitle += '({})'.format(members.length);
        titleType = 2;
      }
      
      $('.chat-empty').hide();
      initChatTitle(channelTitle, titleType);
      $('.chat-canvas').html('');
      sbMessagingInputField.val('');
      $('.chat').show();
      
      navInit();
      popupInit();
      sbMakeMemberList(members);
      
      isOpenChat = false;
      loadMoreChatMessage(scrollPositionBottom);
      // setWelcomeMessage('Messaging Channel');
      addGroupChannel(true, channelMemberList, currChannelInfo, true);
      sbMessagingInputField.attr('disabled', false);
    });
  };
  
  admin_showConfirmModal('상담 시작', '상담 채팅을 시작할까요?',
    {
      label: "상담 시작", action: () => {
        startMessagingProcess();
      }
    },
    {label: "취소", action: null}
  );
}

function deleteChannel(channel) {
  const channelUrl = channel.url ? channel.url : channel.channel_url;
  if (channel.isGroupChannel()) {
    $('.left-nav-channel-group[data-channel-url=' + channelUrl + ']').remove();
    delete (groupChannelLastMessageList[channelUrl]);
  }
  
  if (channel.isOpenChannel()) {
    $('.left-nav-channel-open[data-channel-url=' + channelUrl + ']').remove();
  }
  
  try {
    delete (channelMessageList[channelUrl]);
  } catch (e) {
    // pass
  }
  
  if (channel == currChannelInfo) {
    leaveCurrChannel();
  }
}

function hideCurrChannel() {
  console.log('hideCurrChannel called');
  if (currChannelInfo.isGroupChannel()) {
    currChannelInfo.hide(function (response, error) {
      if (error) {
        return;
      }
      
      $('.chat-canvas').html('');
      sbMessagingInputField.val('');
      $('.chat').hide();
      initChatTitle('', -1);
      $('.chat-empty').show();
      
      $('.left-nav-channel-messaging--active').remove();
      $('.left-nav-channel-group--active').remove();
      
      $('.modal-hide-channel').hide();
      channelListPage = 0;
      currChannelUrl = null;
      currChannelInfo = null;
      leaveMessagingChannelUrl = '';
      
      sbMessagingInputField.attr('disabled', true);
    });
  }
}

function leaveCurrChannel() {
  console.log('leaveCurrChannel called');
  if (currChannelInfo.isOpenChannel()) {
    currChannelInfo.exit(function (response, error) {
      if (error) {
        return;
      }
      $('.chat-canvas').html('');
      sbMessagingInputField.val('');
      $('.chat').hide();
      initChatTitle('', -1);
      $('.chat-empty').show();
      
      $('.left-nav-channel-open--active').remove();
      
      if ($('.left-nav-channel-open').length == 0) {
        $('.left-nav-channel-empty').show();
      }
      
      $('.modal-leave-channel').hide();
      channelListPage = 0;
      currChannelUrl = null;
      currChannelInfo = null;
      leaveChannelUrl = '';
      
      sbMessagingInputField.attr('disabled', true);
    });
  } else if (currChannelInfo.isGroupChannel()) {
    currChannelInfo.leave(function (response, error) {
      if (error) {
        return;
      }
      
      $('.chat-canvas').html('');
      sbMessagingInputField.val('');
      $('.chat').hide();
      initChatTitle('', -1);
      $('.chat-empty').show();
      
      $('.left-nav-channel-messaging--active').remove();
      $('.left-nav-channel-group--active').remove();
      
      $('.modal-leave-channel').hide();
      channelListPage = 0;
      currChannelUrl = null;
      currChannelInfo = null;
      leaveMessagingChannelUrl = '';
      
      sbMessagingInputField.attr('disabled', true);
    });
  }
}


function moveToTopGroupChat(channelUrl) {
  $('.left-nav-channel-group[data-channel-url=' + channelUrl + ']').prependTo('#messaging_channel_list');
}

function sbUpdateGroupChannelLastMessage(message) {
  if (!message) {
    return
  }
  var lastMessage = '??';
  var lastMessageDateString = '';
  let channelUrl = message.channelUrl ? message.channelUrl : message.channel_url;
  lastMessage = xssEscape(message.message);
  const messageCreatedAt = message.createdAt ? message.createdAt : message.created_at;
  var calcSeconds = (new Date().getTime() - messageCreatedAt) / 1000;
  var parsedValue;
  
  if (calcSeconds < 60) {
    parsedValue = parseInt(calcSeconds);
    if (parsedValue == 1) {
      lastMessageDateString = parsedValue + ' 초 전';
    } else {
      lastMessageDateString = parsedValue + ' 초 전';
    }
  } else if (calcSeconds / 60 < 60) {
    parsedValue = parseInt(calcSeconds / 60);
    if (parsedValue == 1) {
      lastMessageDateString = parsedValue + ' 분 전';
    } else {
      lastMessageDateString = parsedValue + ' 분 전';
    }
  } else if (calcSeconds / (60 * 60) < 24) {
    parsedValue = parseInt(calcSeconds / (60 * 60));
    if (parsedValue == 1) {
      lastMessageDateString = parsedValue + ' 시간 전';
    } else {
      lastMessageDateString = parsedValue + ' 시간 전';
    }
  } else {
    lastMessageDateString = moment(messageCreatedAt).format("YYYY.MM.D");
  }
  
  if (lastMessageDateString) {
    lastMessageDateString = '<div><span> ' + lastMessageDateString + '</span></div>';
    //<img src="/img/sb/icon-time.png" />
  }
  
  $('.left-nav-channel-group[data-channel-url=' + channelUrl + '] .left-nav-channel-lastmessage').html(lastMessage);
  $('.left-nav-channel-group[data-channel-url=' + channelUrl + '] .left-nav-channel-lastmessagetime').html(lastMessageDateString);
}

function updateGroupChannelListAll() {
  for (const i in groupChannelLastMessageList) {
    const message = groupChannelLastMessageList[i];
    sbUpdateGroupChannelLastMessage(message);
  }
}

/**
 *
 * @param isGroup 그룹방 여부
 * @param channelMembers 멤버 닉네임 묶음
 * @param targetChannel 해당 채널
 * @param toFront 앞에 놓을지 여부
 */
function addGroupChannel(isGroup, channelMembers, targetChannel, toFront = false) {
  let channelUrl = targetChannel.url ? targetChannel.url : targetChannel.channel_url; // 검색시 키값이 다름...ㅍㅍ
  if (isGroup) {
    let lastMessage = targetChannel.lastMessage ? targetChannel.lastMessage : targetChannel.last_message;
    groupChannelLastMessageList[channelUrl] = lastMessage;
  }
  
  $.each($('.left-nav-channel'), function (index, channel) {
    $(channel).removeClass('left-nav-channel-open--active');
    $(channel).removeClass('left-nav-channel-messaging--active');
    $(channel).removeClass('left-nav-channel-group--active');
  });
  
  let addFlag = true;
  $.each($('.left-nav-channel-messaging'), function (index, channel) {
    if (currChannelUrl == $(channel).data('channel-url')) {
      $(channel).addClass('left-nav-channel-messaging--active');
      $(channel).find('div[class="left-nav-channel__unread"]').remove();
      addFlag = false;
    }
  });
  // 그룹채널에 있는지 체크
  $.each($('.left-nav-channel-group'), function (index, channel) {
    if (currChannelUrl == $(channel).data('channel-url')) {
      $(channel).addClass('left-nav-channel-group--active');
      $(channel).find('div[class="left-nav-channel__unread"]').remove();
      addFlag = false;
    }
  });
  
  if (channelMembers.length > 9) {
    channelMembers = channelMembers.substring(0, 9) + '...';
  }
  
  // targetAddGroupChannel = targetChannel;
  
  if (channelUrl) {
    if (addFlag && !isGroup) {
      const item = `<div class="left-nav-channel left-nav-channel-messaging left-nav-channel-messaging--active" ` +
        `     onclick="sbJoinGroupChannel('${channelUrl}')"` +
        `     data-channel-url="${channelUrl}"` +
        `>${channelMembers}</div>`;
      if (toFront) {
        $('#messaging_channel_list').prepend(item);
      } else {
        $('#messaging_channel_list').append(item);
      }
      
      groupChannelListMembersAndProfileImageUpdate(targetChannel);
    } else if (addFlag && isGroup) {
        // 여기 사용자 사진
      const item = '<div class="left-nav-channel left-nav-channel-group left-nav-channel-group--active" ' +
        '     onclick="sbJoinGroupChannel(\'' + channelUrl + '\')"' +
        '     data-channel-url="' + channelUrl + '"' +
        '>' +
        '<div class="userProfilePic"></div>' +
        '<div class="left-nav-channel-members">' + channelMembers + '</div>' +
        '<div class="left-nav-channel-lastmessage"></div>' +
        '<div class="left-nav-channel-lastmessagetime"></div>' +
        '</div>';
      if (toFront) {
        $('#messaging_channel_list').prepend(item);
      } else {
        $('#messaging_channel_list').append(item);
      }
      // targetAddGroupChannel = null;
      groupChannelListMembersAndProfileImageUpdate(targetChannel);
    }
  }
  
  // $('.modal-guide-create').hide();
  $('.left-nav-button-guide').hide();
}

function groupChannelListMembersAndProfileImageUpdate(targetChannel) {
  // select profileImage
  var members = targetChannel.members;
  var membersProfileImageUrl = [];
  var membersNickname = '';
  
  $.each(members, function (index, member) {
    let userId = member.userId ? member.userId : member.user_id;
    if (currentUser.userId != userId) {
      let profileUrl = member.profileUrl ? member.profileUrl : member.profile_url;
      membersProfileImageUrl.push(profileUrl);
      membersNickname += xssEscape(member.nickname) + ', ';
    }
  });
  membersNickname = membersNickname.slice(0, -2);
  
  // console.log(membersProfileImageUrl);
  const selectSequence = parseInt(Math.random() * membersProfileImageUrl.length);
  // console.log(selectSequence);
  const selectedProfileImageUrl = membersProfileImageUrl[selectSequence];
  // console.log(selectedProfileImageUrl);
  
  const channelUrl = targetChannel.url ? targetChannel.url : targetChannel.channel_url; // 검색시 키값이 다름...ㅍㅍ
  const targetElem = $('.left-nav-channel-group[data-channel-url=' + channelUrl + ']');
  const targetElemImg = targetElem.find('.userProfilePic');
  // $('.left-nav-channel-group[data-channel-url='+channelUrl+']')
  
  // 사용자 사진 새로 만듦
  targetElemImg.css('background-image', 'url(' + selectedProfileImageUrl + ')');
  
  // member nickname update
  targetElem.find('.left-nav-channel-members').html(membersNickname);
  
}

/**
 *
 * @param {string} channelUrl
 * @param {function?} callback
 * @returns {boolean}
 */

function sbJoinGroupChannel(channelUrl, callback) {
  console.log('sbJoinGroupChannel:', channelUrl);
  
  Api.liveMeetingTime(channelUrl)
    .then(function (result) {
      devLog('liveMeetingTime -- ' + result.chat);
      if (result.chat) {
        meetingStart = result.chat.startDate;
        meetingEnd = result.chat.endDate;
        inMeetingTime = true;
        console.log("st : " + meetingStart + "-" + meetingEnd);
        checkInMeeting();
      }
    })
    .catch(function (err) {
      console.log(err)
    });
  
  
  if (channelUrl == currChannelUrl) {
    navInit();
    popupInit();
    $.each($('.left-nav-channel'), function (index, channel) {
      if ($(channel).data('channel-url') == channelUrl) {
        $(channel).find('div[class="left-nav-channel__unread"]').remove();
      }
    });
    return false;
  }
  
  PreviousMessageListQuery = null;
  sb.GroupChannel.getChannel(channelUrl, function (channel, error) {
    if (error) {
      console.log("GroupChannel.getChannel", error);
      return;
    }
    
    channel.markAsRead();
    
    currChannelInfo = channel;
    currChannelUrl = channelUrl;
    
    const members = channel.members;
    let channelTitle = '';
    
    channel.refresh(function () {
      // TODO
    });
    
    sbCurrentTargetUserIds = [];
    $.each(members, function (index, member) {
      if (!sbu.isCurrentUser(member.userId)) {
        sbCurrentTargetUserIds.push(member.userId);
        channelTitle += xssEscape(member.nickname) + ', ';
      }
    });
    
    channelTitle = channelTitle.slice(0, -2);
    const channelMemberList = channelTitle;
    if (channelTitle.length > 30) {
      channelTitle = channelTitle.substring(0, 30);
      channelTitle += '...';
    }
    let titleType = 1;
   // let isGroup = false;
    if (members.length > 2) {
      channelTitle += '({})'.format(members.length);
      titleType = 2;
     // isGroup = true;
    }
    
    $('.chat-empty').hide();
    initChatTitle(channelTitle, titleType);
    $('.chat-canvas').html('');
    sbMessagingInputField.val('');
    $('.chat').show();
    
    navInit();
    popupInit();
    sbMakeMemberList(members);
    
    isOpenChat = false;
    loadMoreChatMessage(scrollPositionBottom);
    // setWelcomeMessage('Group Channel');
    addGroupChannel(true, channelMemberList, currChannelInfo);
    // sbMessagingInputField.attr('disabled', false);
    
    // console.log(userId);
    
    $('.chat-top__button-hide').show();
    if (callback) {
      callback();
    }
  });
}


function isMeetingTime() {
  return false;
  
}

function endMessaging(channel, obj) {
  popupInit();
  leaveMessagingChannelUrl = channel.url;
  $('.modal-leave-channel-desc').html('Do you want to leave this messaging channel?');
  $('.modal-leave-channel').show();
  return false;
}

function hideChannel(channel) {
  popupInit();
  hideChannelUrl = channel.url;
  $('.modal-hide-channel-desc').html('Do you want to hide this channel?');
  $('.modal-hide-channel').show();
  return false;
}

function inviteMember() {
  let selection = $('.modal-messaging-list__icon--select');
  if (selection.length == 0) {
    admin_showConfirmModal('채팅 시작', '회원을 선택해주세요');
    return false;
  }
  
  let userIds = [];
  $.each(selection, function (index, user) {
    if ($(user).data("guest-id")) {
      userIds.push($(user).data("guest-id"));
    }
  });
  
  currChannelInfo.inviteWithUserIds(userIds, function (response, error) {
    if (error) {
      return;
    }
    
    popupInit();
  });
}

/**
 * 개설기간으로 그룹 채널 리스트 검색
 * @param from 개설 기간 범위
 * @param to 개설 기간
 * @param completion 완료 콜백 함수
 */
function sbSearchChannels(from, to) {
  sbGetChannelList(true, from, to, function () {
    updateGroupChannelListAll();
  });
}

/**
 * 그룹 채널 리스트 조회
 * @param {boolean} isFirstPage
 * @param {number?} from milliseconds
 * @param {number?} to milliseconds
 * @param {Function?} completion 조회 완료하면 호출
 */
function sbGetChannelList(isFirstPage, from, to, completion = null) {
  if (isFirstPage) {
    $('#messaging_channel_list').html('');
    sbSearchChannelsNextToken = '';
    sbResetChannelListQuery();
  }
  
  let channelCountEl = $('#channelCount');
  let channelAllCountEl = $('#channelAllCount');
  let handleChannels = function (channels, error) {
    let moreBt = $('.messaging_channel_list-more');
    if (moreBt) {
      moreBt.remove();
    }
    if (error) {
      channelCountEl.html("");
      console.log(error);
      return;
    }
    devLog("loaded channels.length " + channels.length);
    let unreadCountMap = new Map();
    channels.forEach(function (channel) {
      let channelMemberList = '';
      let members = channel.members;
      let targetUrl = channel.url ? channel.url : channel.channel_url;
      
      members.forEach(function (member) {
        let memberId = member.userId ? member.userId : member.user_id;
        if (currentUser.userId != memberId) {
          channelMemberList += xssEscape(member.nickname) + ', ';
        }
      });
      
      channelMemberList = channelMemberList.slice(0, -2);
      // 채널 리스트에 아이템 추가
      addGroupChannel(true, channelMemberList, channel);
      
      let unreadMessageCount = channel.unreadMessageCount ?
        channel.unreadMessageCount : channel.unread_message_count;
      unreadCountMap.set(targetUrl, unreadMessageCount);
    }); // for channels
    
    let channelEls = $('.left-nav-channel');
    $.each(channelEls, function (index, item) {
      $(item).removeClass('left-nav-channel-messaging--active');
      $(item).removeClass('left-nav-channel-group--active');
      let itemUrl = $(item).data("channel-url");
      let unread = unreadCountMap.get(itemUrl);
      if (unread) {
        let countText = unread > 9 ? '9+' : unread;
        addUnreadCount(item, countText, itemUrl);
      }
    });
    
    // let unread = unreadMessageCount > 9 ? '9+' : unreadMessageCount;
    // if (unread && unread > 0) {
    //   $.each(channelEls, function (index, item) {
    //     if ($(item).data("channel-url") == targetUrl) {
    //       addUnreadCount(item, unread, targetUrl);
    //     }
    //   });
    // }
    
    
    let channelsCount = channelEls.length;
    channelCountEl.html("채널수 : " + channelsCount);
    
    if (sbHasNextChannelListPage()) {
      $('#messaging_channel_list').append(
        '<div class="messaging_channel_list-more" onclick="sbGetChannelListMore()">MORE<div class="modal-messaging-more__icon"></div></div>'
      );
    }
    
    ApiSb.getGroupChannelCount(currentUser.userId)
      .then(function (res) {
        if (res.group_channel_count) {
          channelAllCountEl.html(` / 총 ${res.group_channel_count}`);
        }
      })
      .catch(function (e) {
        console.log(e);
      })
    
    
    if (completion) {
      completion();
    }
  };
  
  sbSearchChannlesFrom = from;
  sbSearchChannlesTo = to;
  if (from && to) {
    sbChannelListQuery = null;
    ApiSb.searchGroupChannelList(currentUser.userId, from, to, sbSearchChannelsNextToken).then(function (res) {
      sbSearchChannelsNextToken = res.next;
      handleChannels(res.channels, null);
    }).catch(function (e) {
      sbSearchChannelsNextToken = '';
      handleChannels([], e);
    });
  } else {
    devLog("loading....  default channel list")
    sbSearchChannelsNextToken = '';
    if (sbChannelListQuery) {
      sbChannelListQuery.next(handleChannels);
    }
  }
  
}

function sbHasNextChannelListPage() {
  return sbSearchChannelsNextToken || (sbChannelListQuery && sbChannelListQuery.hasNext)
}

function sbGetChannelListMore() {
  sbGetChannelList(false, sbSearchChannlesFrom, sbSearchChannlesTo);
}

function sbMakeMemberList(members) {
  let item = {};
  //Clear memberList before updating it
  memberList = [];
  $.each(members, function (index, member) {
    item = {};
    if (!sbu.isCurrentUser(member['user_id'])) {
      item["user_id"] = member["user_id"];
      item["name"] = xssEscape(member["name"]);
      memberList.push(item);
    }
  });
}

/***********************************************
 *            // END MESSAGING
 **********************************************/


/***********************************************
 *            SendBird Settings
 **********************************************/

/**
 * SendBird
 */
var sb;

/**
 * GroupChannelListQuery
 */
var sbChannelListQuery;
/**
 *  사용자 조회 쿼리
 */
var sbUserListQuery;
var sbSendMessageHandler;
/**
 *  메시지 보내고 나면 호출
 */
var sbSentMessageCallback;
var sbUserList = {};
var sbIsInit = false;

var channelMessageList = {};
var groupChannelLastMessageList = {};


function startSendBird(appId, userId, nickName) {
  console.log('startSendBird ' + userId + ' ' + nickName)
  sb = new SendBird({
    appId: appId, localCacheEnabled: true
  });
  sb.connect(userId, function (user, error) {
    if (error) {
      console.log(error.toString());
    } else {
      initPage(user);
    }
  });
  
  let initPage = function (user) {
    
    currentUser = user;
    sb.updateCurrentUserInfo(nickName, '', function (response, error) {
      // console.log('updateCurrentUserInfo', response, error);
    });
    
    sbResetChannelListQuery();
    sbUserListQuery = sb.createUserListQuery();
    sbUserListQuery.limit = 100;
    
    if (sbWithChannelList) {
      sbGetChannelList(true, undefined, undefined, function () {
        updateGroupChannelListAll();
      });
      setTimeout(function () {
        setInterval(function () {
          updateGroupChannelListAll();
        }, 1000);
      }, 2000);
    }
    
    sbIsInit = true;
    $('.init-check').hide();
    
    devLog('sb initialized - ' + user.userId);
  };
  
  const connectionHandler = new sb.ConnectionHandler();
  connectionHandler.onReconnectStarted = function (id) {
    devLog('onReconnectStarted');
  };
  
  connectionHandler.onReconnectSucceeded = function (id) {
    devLog('onReconnectSucceeded');
    if (!sbIsInit) {
      initPage();
    }
    
    // OpenChannel list reset
    // 오픈 채널을 사용하지 않음.
    // if ($('.right-section__modal-bg').is(':visible')) {
    //   let withoutCache = true;
    //   sbGetOpenChannelList(withoutCache);
    // }
    
    // GroupChannel list reset
    // sbResetChannelListQuery();
    $('#messaging_channel_list').html('');
    sbGetChannelList(true);
    
    setTimeout(function () {
      updateGroupChannelListAll();
      setInterval(function () {
        updateGroupChannelListAll();
      }, 1000);
    }, 500);
  };
  
  connectionHandler.onReconnectFailed = function (id) {
    console.log('onReconnectFailed');
  };
  sb.addConnectionHandler('keep_chat_connection', connectionHandler);
  
  sbSendMessageHandler = function (message, error) {
    
    if (error) {
      if (error.code == 900050) {
        setSysMessage({
          'message': 'This channel is freeze.'
        });
        console.log("sbSendMessageErrorHandler :: " + error.message);
        return;
      } else if (error.code == 900041) {
        setSysMessage({
          'message': 'You are muted.'
        });
        console.log("sbSendMessageErrorHandler :: " + error.message);
        return;
      }
      console.log(error);
    }
    if (!message) return;
    
    // update last message
    const channelUrl = message.channelUrl ? message.channelUrl : message.channel_url;
    if (groupChannelLastMessageList.hasOwnProperty(channelUrl)) {
      groupChannelLastMessageList[channelUrl] = message;
      sbUpdateGroupChannelLastMessage(message);
    }
    
    if (message.isUserMessage()) {
      setChatMessage(message);
    }
    
    if (message.isFileMessage()) {
      $('.chat-input-file').removeClass('file-upload');
      sbFileInputField.val('');
      
      if (message.type.match(/^image\/.+$/)) {
        setImageMessage(message);
      } else {
        setFileMessage(message);
      }
    }
  };
  
  const groupChannelHandler = new sb.ChannelHandler();
  groupChannelHandler.onMessageReceived = function (channel, message) {
    var isCurrentChannel = false;
    
    if (currChannelInfo == channel) {
      isCurrentChannel = true;
    }
    
    channel.refresh(function () {
    });
    
    // update last message
    if (channel.isGroupChannel()) {
      groupChannelLastMessageList[channel.url] = message;
      sbUpdateGroupChannelLastMessage(message);
      moveToTopGroupChat(channel.url);
    }
    
    if (isCurrentChannel && channel.isGroupChannel()) {
      channel.markAsRead();
    } else {
      if (channel.isGroupChannel()) {
        unreadCountUpdate(channel);
      }
    }
    
    if (!document.hasFocus()) {
      sbu.notifyMessage(channel, xssEscape(message.message));
    }
    
    if (message.isUserMessage() && isCurrentChannel) {
      setChatMessage(message);
    }
    
    if (message.isFileMessage() && isCurrentChannel) {
      $('.chat-input-file').removeClass('file-upload');
      sbFileInputField.val('');
      
      if (message.type.match(/^image\/.+$/)) {
        setImageMessage(message);
      } else {
        setFileMessage(message);
      }
    }
    
    if (message.isAdminMessage() && isCurrentChannel) {
      setBroadcastMessage(message);
    }
  };
  
  groupChannelHandler.onReadReceiptUpdated = function (channel) {
    //console.log('ChannelHandler.onReadReceiptUpdated: ', channel);
    updateChannelMessageCacheAll(channel);
  };
  
  groupChannelHandler.onTypingStatusUpdated = function (channel) {
    //console.log('ChannelHandler.onTypingStatusUpdated: ', channel);
    if (channel == currChannelInfo) {
      showTypingUser(channel);
    }
  };
  
  groupChannelHandler.onUserLeft = function (channel, user) {
    //console.log('ChannelHandler.onUserLeft: ', channel, user);
    setSysMessage({
      'message': '"' + xssEscape(user.nickname) + '" user is left.'
    });
    
    if (channel.isGroupChannel()) {
      groupChannelListMembersAndProfileImageUpdate(channel);
    }
  };
  
  groupChannelHandler.onUserBanned = function (channel, user) {
    console.log('ChannelHandler.onUserBanned: ', channel, user);
    if (sbu.isCurrentUser(user.userId)) {
      alert('Oops...You got banned out from this channel.');
      navInit();
      popupInit();
    } else {
      setSysMessage({
        'message': '"' + xssEscape(user.nickname) + '" user is banned.'
      });
    }
  };
  
  groupChannelHandler.onUserUnbanned = function (channel, user) {
    console.log('ChannelHandler.onUserUnbanned: ', channel, user);
    setSysMessage({
      'message': '"' + xssEscape(user.nickname) + '" user is unbanned.'
    });
  };
  
  groupChannelHandler.onChannelChanged = function (channel) {
    if (channel.isGroupChannel()) {
      groupChannelListMembersAndProfileImageUpdate(channel);
    }
  };
  
  groupChannelHandler.onChannelDeleted = function (channel) {
    deleteChannel(channel);
  };
  
  sb.addChannelHandler('group_channel_handler', groupChannelHandler);
}

///<--- startSendbird

/**
 * 그룹 채널 리스트 쿼리 초기화
 */
function sbResetChannelListQuery() {
  sbChannelListQuery = sb.GroupChannel.createMyGroupChannelListQuery();
  sbChannelListQuery.includeEmpty = true;
  sbChannelListQuery.order = 'latest_last_message';
  sbChannelListQuery.limit = 50;
  sbChannelListQuery.memberStateFilter = 'joined_only';
}


const showTypingUser = function (channel) {
  if (!channel.isGroupChannel()) {
    return;
  }
  
  let chatInputTyping = $('.chat-input-typing');
  if (!channel.isTyping()) {
    chatInputTyping.hide();
    chatInputTyping.html('');
    return;
  }
  
  var typingUser = channel.getTypingMembers();
  
  var nicknames = '';
  for (var i in typingUser) {
    var nickname = xssEscape(typingUser[i].nickname);
    nicknames += nickname + ', ';
  }
  if (nicknames.length > 2) {
    nicknames = nicknames.substring(0, nicknames.length - 2);
    chatInputTyping.html('{} typing...'.format(nicknames));
    chatInputTyping.show();
  } else {
    chatInputTyping.hide();
    chatInputTyping.html('');
  }
};


/***********************************************
 *          // END SendBird Settings
 **********************************************/


/***********************************************
 *              Common Function
 **********************************************/
function initChatTitle(title, index) {
  let chatTopTitle = $('.chat-top__title');
  chatTopTitle.html(title);
  chatTopTitle.show();
  $('.chat-top-button').show();
  $('.chat-top__button-invite').hide();
  chatTopTitle.removeClass('chat-top__title--messaging');
  chatTopTitle.removeClass('chat-top__title--group');
  if (index == -1) {
    $('.chat-top__title').hide();
    $('.chat-top-button').hide();
  } else if (index == 0) {
    sbCurrentUsersButton.removeClass('chat-top__button-member__all');
    sbCurrentUsersButton.addClass('chat-top__button-member__right');
  } else {
    if (index == 1) {
      $('.chat-top__title').addClass('chat-top__title--messaging');
    } else {
      $('.chat-top__title').addClass('chat-top__title--group');
    }
    sbCurrentUsersButton.removeClass('chat-top__button-member__right');
    sbCurrentUsersButton.addClass('chat-top__button-member__all');
    $('.chat-top__button-invite').show();
  }
}

var scrollPositionBottom = function () {
  var scrollHeight = $('.chat-canvas')[0].scrollHeight;
  $('.chat-canvas')[0].scrollTop = scrollHeight;
  currScrollHeight = scrollHeight;
};

function afterImageLoad(obj) {
  $('.chat-canvas')[0].scrollTop = $('.chat-canvas')[0].scrollTop + obj.height + $('.chat-canvas__list').height();
}

function setChatMessage(message) {
  $('.chat-canvas').append(messageList(message));
  
  updateChannelMessageCache(currChannelInfo, message);
  scrollPositionBottom();
}


function loadMoreChatMessage(func) {
  if (!PreviousMessageListQuery) {
    PreviousMessageListQuery = currChannelInfo.createPreviousMessageListQuery();
  }
  
  PreviousMessageListQuery.load(30, false, function (messages, error) {
    if (error) {
      return;
    }
    
    var moreMessage = messages;
    var msgList = '';
    messages.forEach(function (message) {
      // console.log(message);
      switch (message.messageType) {
        case 'user':
          msgList += messageList(message);
          break;
        case 'file':
          $('.chat-input-file').removeClass('file-upload');
          sbFileInputField.val('');
          if (message.type.match(/^image\/.+$/)) {
            msgList += imageMessageList(message);
          } else {
            msgList += fileMessageList(message);
          }
          break;
        default:
      }
    });
    
    $('.chat-canvas').prepend(msgList);
    $('.chat-canvas')[0].scrollTop = (moreMessage.length * MESSAGE_TEXT_HEIGHT);
    
    for (var i in messages) {
      var message = messages[i];
      updateChannelMessageCache(currChannelInfo, message);
    }
    
    if (func) {
      func();
    }
  });
}

function messageList(message) {
  let msgList = '';
  let user = message.sender;
  if (message.isAdminMessage()) {
    // console.log(message);
  } else {
    if (sbu.isCurrentUser(user.userId)) {
      let readReceiptHtml = '  <label class="chat-canvas__list-readreceipt"></label>';
      // 내 메시지
      let msg = '' +
        '<div class="chat-canvas__list chat-message-right pb-4">' +
        '<div>' +
        // '  <img style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;" src="' + user.profileUrl +'">' +
        // '  <label class="chat-canvas__list-name chat-canvas__list-name__user" data-userid="%userid%">' +
        // xssEscape(user.nickname) +
        // '  </label>' +
        '  <label class="chat-canvas__list-separator">:</label>' +
        '  <label class="chat-canvas__list-text bg-light rounded py-2 px-3 mb-1" data-messageid="%messageid%">%message%</label>' +
        '  <label class="small text-muted">' + new Date(message.createdAt).toLocaleString() + '</label>' +
        '</div>' +
        '</div>';
      msg = msg.replace('%message%', sbu.convertLinkMessage(xssEscape(message.message)));
      msg = msg.replace('%userid%', user.userId).replace('%messageid%', message.messageId);
      
      msgList += msg;
    } else {
      // 상대방 메시지
      let msg = '' +
        '<div class="chat-canvas__list chat-message-left pb-4">' +
        '<div><img style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;" src="' + user.profileUrl + '"></div>' +
        '<div class="flex-shrink-1 ml-3">' +
        '  <label class="chat-canvas__list-name font-weight-bold mb-1" data-userid="%userid%" data-nickname="%nickname%">' +
        xssEscape(user.nickname) +
        '  </label>' +
        '  <label class="chat-canvas__list-separator">:</label>' +
        '  <label class="chat-canvas__list-text bg-primary text-white rounded py-2 px-3 mb-1" data-messageid="%messageid%">' +
        sbu.convertLinkMessage(xssEscape(message.message)) +
        '  </label>' +
        ' <label class="small text-muted">' + new Date(message.createdAt).toLocaleString() + '</label> ' +
        '</div>' +
        '</div>';
      msgList += msg.replace('%userid%', user.userId).replace('%nickname%', xssEscape(user.nickname)).replace('%messageid%', message.messageId);
    }
  }
  
  return msgList;
}

function updateChannelMessageCache(channel, message) {
  var readReceipt = -1;
  if (channel.isGroupChannel()) {
    readReceipt = channel.getReadReceipt(message);
  }
  if (!channelMessageList.hasOwnProperty(channel.url)) {
    channelMessageList[channel.url] = {};
  }
  
  if (!channelMessageList[channel.url].hasOwnProperty(message.messageId)) {
    channelMessageList[channel.url][message.messageId] = {};
  }
  
  channelMessageList[channel.url][message.messageId]['message'] = message;
  
  
  // toDo 아래 스크핍트 정체가 뭔지 알아야 함.
  // 아래 스크립트가 있으면 메시지 뒤 추가한 태그를 숨겨버림.
  // 원래 구조는 메지시 뒤 next() 가 없음.
  
  // if (channel.isGroupChannel() && readReceipt >= 0) {
  //   channelMessageList[channel.url][message.messageId]['readReceipt'] = readReceipt;
  //
  //   var elemString = '.chat-canvas__list-text[data-messageid=' + message.messageId + ']';
  //   var elem = $(elemString).next();
  //   if (readReceipt == 0) {
  //     // elem.html('').hide();
  //   } else {
  //     elem.html(readReceipt);
  //     if (!elem.is(':visible')) {
  //       elem.show();
  //     }
  //   }
  // } else {
  //   return;
  // }
}

function updateChannelMessageCacheAll(channel) {
  for (var i in channelMessageList[channel.url]) {
    var message = channelMessageList[channel.url][i]['message'];
    updateChannelMessageCache(channel, message);
  }
}

function fileMessageList(message) {
  let msgList = '';
  let user = message.sender;
  let profileUrl = user.profileUrl ? user.profileUrl : '/img/profile_default@3x.jpg';
  if (sbu.isCurrentUser(user.userId)) {
    msgList += '' +
      '<div class="chat-canvas__list chat-message-right pb-4">' +
      '  <label class="chat-canvas__list-name chat-canvas__list-name__user">' +
      xssEscape(user.nickname) +
      '  </label>' +
      '  <label class="chat-canvas__list-separator">:</label>' +
      '  <label class="chat-canvas__list-text" data-messageid="%messageid%">'.replace('%messageid%', message.messageId) +
      '    <label class="chat-canvas__list-text-file">FILE</label>' +
      '    <a href="' + xssEscape(message.url) + '" target="_blank">' + xssEscape(message.name) + '</a>' +
      '  </label>' +
      '</div>';
  } else {
    msgList += '' +
      '<div class="chat-canvas__list chat-message-left pb-4">' +
      '<div><img style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;" src="' + profileUrl + '"></div>' +
      '<div class="flex-shrink-1 ml-3">' +
      '  <label class="chat-canvas__list-name font-weight-bold mb-1" data-userid="%userid%" data-nickname="%nickname%">' +
      xssEscape(user.nickname) +
      '  </label>' +
      '  <label class="chat-canvas__list-separator">:</label>' +
      '  <label class="chat-canvas__list-text" data-messageid="%messageid%">'.replace('%messageid%', message.messageId) +
      '    <label class="chat-canvas__list-text-file">FILE</label>' +
      '    <a href="' + xssEscape(message.url) + '" target="_blank">' + xssEscape(message.name) + '</a>' +
      '  </label>' +
      '</div>' +
      '</div>';
  }
  
  // var channel = currChannelInfo;
  // updateChannelMessageCache(channel, message);
  
  return msgList;
}

function imageMessageList(obj) {
  let msgList = '';
  let message = obj;
  let user = message.sender;
  let profileUrl = user.profileUrl ? user.profileUrl : '/img/profile_default@3x.jpg';
  if (sbu.isCurrentUser(user.userId)) {
    msgList += '' +
      '<div class="chat-canvas__list chat-message-right pb-4">' +
      '  <label class="chat-canvas__list-name chat-canvas__list-name__user">' +
      xssEscape(user.nickanme) +
      '  </label>' +
      '  <label class="chat-canvas__list-separator">:</label>' +
      // '  <label class="chat-canvas__list-text" data-messageid="%messageid%">'.replace('%messageid%', message.messageId) +
      // xssEscape(message.name) +
      // '  </label>' +
      '  <div class="chat-canvas__list-file" onclick="window.open(\'' + xssEscape(message.url) + '\', \'_blank\');">' +
      '    <img src="' + xssEscape(message.url) + '" class="chat-canvas__list-file-img" onload="afterImageLoad(this)">' +
      '  </div>' +
      '</div>';
  } else {
    msgList += '' +
      '<div class="chat-canvas__list chat-message-left pb-4">' +
      '<div><img style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover;" src="' + profileUrl + '"></div>' +
      '<div class="flex-shrink-1 ml-3">' +
      '  <label class="chat-canvas__list-name font-weight-bold mb-1" data-userid="%userid%" data-nickname="%nickname%">' +
      xssEscape(user.nickname) +
      '  </label>' +
      '  <label class="chat-canvas__list-separator">:</label>' +
      // '  <label class="chat-canvas__list-text" data-messageid="%messageid%">'.replace('%messageid%', message.messageId) +
      // xssEscape(message.name) +
      // '  </label>' +
      '  <div class="chat-canvas__list-file" onclick="window.open(\'' + xssEscape(message.url) + '\', \'_blank\');">' +
      '    <img src="' + xssEscape(message.url) + '" class="chat-canvas__list-file-img" onload="afterImageLoad(this)">' +
      '  </div>' +
      '</div>' +
      '</div>';
  }
  
  return msgList;
}

function setWelcomeMessage(name) {
  $('.chat-canvas').append(
    '<div class="chat-canvas__list-notice">' +
    '  <label class="chat-canvas__list-system">' +
    'Welcome to {}!'.format(name) +
    '  </label>' +
    '</div>'
  );
}


sbMessagingInputField.keydown(function (event) {
  sbMessageSendButton.attr('disabled', false); // 타이핑 시작되면 발송 버튼 활성화
  
  if (event.keyCode == 13 && !event.shiftKey) {
    event.preventDefault();
    if (!$.trim(this.value).isBlank()) {
      event.preventDefault();
      let text = $.trim(this.value);
      this.value = text;
      currChannelInfo.sendUserMessage(text, '', sbSendMessageHandler); // v3
      if (sbSentMessageCallback) sbSentMessageCallback('text');
      scrollPositionBottom();
    }
    this.value = "";
    sbMessageSendButton.attr('disabled', true); // 발송후 버튼 비활성화
    addChatCount(currChannelInfo); // 채팅카운트 ADD
  } else {
    if (!$.trim(this.value).isBlank()) {
      if (!currChannelInfo.isOpenChannel()) {
        currChannelInfo.startTyping();
      }
    } else {
      sbMessageSendButton.attr('disabled', true); // 입력폼을 다 지워서 비워지면 비활성화
      $('.chat-input-file, .chat-input-text__field, .sendbirdMessageSendBtn').css('height', '40px');// 발송 후 입력폼 크기 되돌리기
    }
  }
});

sbMessagingInputField.keyup(function (event) {
  let height = $(this).prop('scrollHeight');
  height = Math.min(height, 70);
  // console.log("keyup "+ height);
  $(this).height(height);
  $(this).parent().prev('label').height(height);
  $(this).parent().next('button').height(height + 4); // 왜 4픽셀만큼 차이날까..
  if ($.trim(this.value).isBlank()) {
    sbMessageSendButton.attr('disabled', true); // 입력폼을 다 지워서 비워지면 비활성화
    $('.chat-input-file, .chat-input-text__field, .sendbirdMessageSendBtn').css('height', '40px');// 발송 후 입력폼 크기 되돌리기
  } else {
    sbMessageSendButton.attr('disabled', false);
  }
});


// 발송 버튼 만들기
sbMessageSendButton.click(function (e) {
  let messageText = sbMessagingInputField.val();
  if (!$.trim(messageText).isBlank()) {
    currChannelInfo.sendUserMessage(messageText, '', sbSendMessageHandler); // v3
    if (sbSentMessageCallback) sbSentMessageCallback('text');
    scrollPositionBottom();
    addChatCount(currChannelInfo); // 채팅카운트 ADD
    sbMessagingInputField.val('');
    sbMessageSendButton.attr('disabled', true); // 발송후 버튼 비활성화
    $('.chat-input-file, .chat-input-text__field, .sendbirdMessageSendBtn').css('height', '40px');// 발송 후 입력폼 크기 되돌리기
  }
});


sbFileInputField.change(function () {
  if (sbFileInputField.val().trim().length == 0) return;
  const file = sbFileInputField[0].files[0];
  $('.chat-input-file').addClass('file-upload');
  
  currChannelInfo.sendFileMessage(file, sbSendMessageHandler); // v3
  if (sbSentMessageCallback) {
    if (file.type.indexOf('image') >= 0) {
      sbSentMessageCallback('image');
    } else {
      sbSentMessageCallback('file');
    }
  }
});

function setImageMessage(obj) {
  $('.chat-canvas').append(imageMessageList(obj));
  scrollPositionBottom();
}

function setFileMessage(obj) {
  $('.chat-canvas').append(fileMessageList(obj));
  scrollPositionBottom();
}

$('.chat-canvas').on('scroll', function () {
  setTimeout(function () {
    var currHeight = $('.chat-canvas').scrollTop();
    if (currHeight == 0) {
      if ($('.chat-canvas')[0].scrollHeight > $('.chat-canvas').height()) {
        loadMoreChatMessage();
      }
    }
  }, 200);
});

function setSysMessage(obj) {
  $('.chat-canvas').append(
    '<div class="chat-canvas__list-notice">' +
    '  <label class="chat-canvas__list-system">' +
    xssEscape(obj['message']) +
    '  </label>' +
    '</div>'
  );
  scrollPositionBottom();
}

function setBroadcastMessage(obj) {
  $('.chat-canvas').append(
    '<div class="chat-canvas__list">' +
    '  <label class="chat-canvas__list-broadcast">' +
    xssEscape(obj['message']) +
    '  </label>' +
    '</div>'
  );
  scrollPositionBottom();
}

function unreadCountUpdate(channel) {
  var targetUrl = channel.url;
  
  var callAdd = true;
  var unread = channel.unreadMessageCount > 9 ? '9+' : channel.unreadMessageCount;
  if (unread > 0 || unread == '9+') {
    $.each($('.left-nav-channel'), function (index, item) {
      if ($(item).data("channel-url") == targetUrl) {
        addUnreadCount(item, unread, targetUrl);
        callAdd = false;
      }
    });
    
    if (callAdd) {
      showChannel(channel, unread, targetUrl);
    }
  } else {
    showChannel(channel, unread, targetUrl);
  }
}

function addUnreadCount(item, unread, targetUrl) {
  if (targetUrl == currChannelUrl) {
    if (document.hasFocus()) {
      return;
    }
  }
  
  if ($(item).find('div[class="left-nav-channel__unread"]').length != 0) {
    $(item).find('div[class="left-nav-channel__unread"]').html(unread);
  } else {
    $('<div class="left-nav-channel__unread">' + unread + '</div>')
      .prependTo('.left-nav-channel-group[data-channel-url=' + targetUrl + ']');
  }
}

function showChannel(channel, unread, targetUrl) {
  var members = channel.members;
  var channelMemberList = '';
  $.each(members, function (index, member) {
    if (currentUser.userId != member.userId) {
      channelMemberList += xssEscape(member.nickname) + ', ';
    }
  });
  channelMemberList = channelMemberList.slice(0, -2);
  addGroupChannel(true, channelMemberList, channel);
  
  if (unread != 0) {
    $.each($('.left-nav-channel'), function (index, item) {
      if ($(item).data("channel-url") == targetUrl) {
        addUnreadCount(item, unread, targetUrl);
      }
    });
  }
}

function template(strings, ...keys) {
  return (function (...values) {
    var dict = values[values.length - 1] || {};
    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });
    return result.join('');
  });
}

function groupChannelOrderRefresh() {
  sbResetChannelListQuery();
  $('#messaging_channel_list').html('');
  sbGetChannelList(true);
}

/***********************************************
 *          // END Common Function
 **********************************************/


$('.right-section__modal-bg').click(function () {
  navInit();
  popupInit();
});

function navInit() {
  $('.right-section__modal-bg').hide();
  
  // OPEN CHAT
  // sbOpenMessagingStartBt.removeClass('left-nav-open--active');
  // $('.modal-open-chat').hide();
  
  // MESSAGING
  sbMessagingStartBt.removeClass('left-nav-messaging--active');
  $('.modal-messaging').hide();
}

function popupInit() {
  $('.modal-member').hide();
  sbCurrentUsersButton.removeClass('chat-top__button-member--active');
  $('.modal-invite').hide();
  $('.chat-top__button-invite').removeClass('chat-top__button-invite--active');
}

/**
 * sendbird initialize
 * @param {string} appId
 * @param {string} userId sendbird user id
 * @param {string} username
 */
function sbInit(appId, userId, username, withChannelList = true) {
  sbNickname = username;
  sbUserId = userId;
  sbWithChannelList = withChannelList
  // if ($(location).attr('pathname') == '/admin/chat') {
  //   sbNickname = 'keepfit';
  //   sbUserId = 'keepfit';
  // }
  // sbUserId = sbu.checkUserId(sbUserId);
  
  $('.init-check').show();
  if (sbUserId) {
    startSendBird(appId, sbUserId, sbNickname);
  }
  // $('.left-nav-user-nickname').html(xssEscape(nickname));
}

function makeMessage(type, params) {
  const userName = params.userName ? params.userName : '';
  const coachName = params.coachName ? params.coachName : '';
  const classTitle = params.classTitle ? params.classTitle : '';
  const messages = {
    'startProgram': `프로그램 결제 성공!\n${coachName} - ${classTitle}`,
    'start': `안녕하세요, ${userName}님. 오늘부터 함께, KEEPFIT!`,
    'manager_1': `반가워요! 전담 운동 매니저 다혜입니다. ${userName}님 운동하시면서 힘든 점이 있으신가요? \n코치님께 직접 말하기 어려운 건 저에게 알려주세요. \n상담시간은 평일 오전 10시부터 오후 6시까지입니다.`,
    'manager_2': `서비스 이용 중에 궁금하신 점은 카카오톡 채널 [에드핏]으로 문의해주세요. 빠르고 정확하게 답변해드립니다.`
  };
  
  return messages[type];
}

/***********************************************
 *          // Custom Function
 **********************************************/
function sbSendMessage(req) {
  const message = makeMessage(req.type, req.messageSet);
  const data = {
    'channelUrl': req.channelUrl,
    'channelType': channelType,
    'message': message,
    'sender': req.sender
  };
  
  ApiSb.sendbirdSendMessage(data)
    .then(function (res) {
      console.log(res);
      return res;
    })
  
}

async function newChannel(req) {
  var userId = req.userId;
  var userName = req.userName;
  var userProfile = req.userProfile;
  var coachId = req.coachId;
  var coachName = req.coachName;
  var coachProfile = req.coachProfile;
  var userClassId = req.userClassId;
  var sbUserId = '';
  var sbCoachId = '';
  
  try {
    sbUserId = await getUser(userId, 'user');
    if (!sbUserId) {
      sbUserId = await createUser(userId, userName, userProfile, 'user');
    }
    sbCoachId = await getUser(coachId, 'coach');
    if (!sbCoachId) {
      sbCoachId = await createUser(coachId, coachName, coachProfile, 'coach');
    }
    let channel = await sbCreateChannel(sbUserId, sbCoachId);
    let channelInfo = '';
    if (channel) {
      channelInfo = await saveChannel(userId, coachId, userClassId, channel.name, channel.url);
      return channelInfo.chat;
    }
  } catch (e) {
    throw new Error('채팅 사용자를 생성할 수 없습니다.');
  }
}


function getChannel(userId, coachId) {
  return new Promise(resolve => {
    Api.getSbChannel(userId, coachId)
      .then(function (res) {
        resolve(res);
      })
  });
}

function saveChannel(userId, coachId, classId, channelName, channelUrl) {
  return new Promise(resolve => {
    Api.saveSbChannel(userId, coachId, classId, channelName, channelUrl, channelType)
      .then(function (res) {
        resolve(res);
      })
  });
}

function sbCreateChannel(userId, coachId) {
  return new Promise(resolve => {
    let chatName = userId + '_' + coachId;
    let users = [];
    users.push(userId);
    users.push(coachId);
    let isDistinct = true;
    if (userId && coachId) {
      sb.GroupChannel.createChannelWithUserIds(users, isDistinct, chatName, '', '', function (channel, error) {
        if (error) {
          // console.log('err: ' + error);
          return;
        }
        // console.log('ch-: ' + JSON.stringify(channel));
        resolve(channel);
      });
    }
  });
}

/**
 * 사용자 정보
 * @param userId 에드핏 userId
 * @param type coach or user
 * @returns {Promise<number>}
 */
function getUser(userId, type) {
  
  return new Promise(resolve => {
    if (type == 'coach') {
      userId = 'c' + userId;
    } else {
      userId = 'u' + userId;
    }
    
    ApiSb.sendbirdGetUser(userId)
      .then(function (res) {
        resolve(res.user_id);
      })
      .catch(function (err) {
        console.log(err);
        resolve('');
      })
  });
}


function createUser(userId, userName, userProfile, type) {
  return new Promise(resolve => {
    if (type == 'coach') {
      userId = 'c' + userId;
    } else {
      userId = 'u' + userId;
    }
    var items = {
      'user_id': userId,
      'nickname': userName,
      'profile_url': userProfile
    }
    ApiSb.sendbirdCreateUser(items)
      .then(function (result) {
        resolve(result.user_id);
      })
  });
}


function updateUser(userId, userName, userProfile, type) {
  return new Promise(resolve => {
    if (type == 'coach') {
      userId = 'c' + userId;
    } else {
      userId = 'u' + userId;
    }
    var items = {
      'user_id': userId,
      'nickname': userName,
      'profile_url': userProfile
    }
    ApiSb.sendbirdUpdateUser(items)
      .then(function (result) {
        resolve(result);
      })
  });
}


function createSbUser(userId, userName, userProfile, userPhone, type) {
  if (type == 'user') userName = userName + '(' + userPhone.substring(userPhone.length - 4) + ')';
  createUser(userId, userName, userProfile, type);
}

function updateSbUser(userId, userName, userProfile, userPhone, type) {
  if (type == 'user') userName = userName + '(' + userPhone.substring(userPhone.length - 4) + ')';
  updateUser(userId, userName, userProfile, type);
}


function addChatCount(channel) {
  if (sbUserId === 'c2') return;
  return new Promise(resolve => {
    Api.addChatCount(channel.url, {date: new Date(), count: 1})
      .then(function (result) {
        resolve(result);
      })
  });
}

function getMeetingTime(channel) {
  return new Promise(resolve => {
    
    ApiSb.sendbirdMeetingTime(channel)
      .then(function (result) {
        resolve(result.user_id);
      })
  });
}


function getLastSchedule(channel) {
  return new Promise(resolve => {
    Api.liveMeetingTime(channel)
      .then(function (result) {
        resolve(result.user_id);
      })
      .catch(function (err) {
        console.log(err)
      })
  });
}

/**
 *
 * @param userClassId
 * @param classTitle
 * @param user
 * @param coach
 * @returns {Promise<string | * | undefined>}
 */
function sbCreateEmptyChat(userClassId, classTitle, user, coach) {
  console.log("sbCreateEmptyChat");
  const setItem = {
    'userId': user.id,
    'userName': user.name,
    'userProfile': user.profileUrl,
    'coachId': coach.id,
    'coachName': coach.name,
    'coachProfile': coach.profileUrl,
    'userClassId': userClassId
  };
  // console.log(setItem);
  return newChannel(setItem) // sendbird 채널 생성
    .then(function (channel) {
      console.log('sbc - sbCreateEmptyChat' + channel.channelUrl);
      return channel.channelUrl;
    });
}

function inputAble(status) {
  // console.log('inputAble : ' + status);
  if (status == 'false') { // 유저만
    sbFileInputField.attr('disabled', true);
    sbMessagingInputField.attr('disabled', true);
    sbMessagingInputField.attr('placeholder', '프로그램이 종료되었습니다.');
  }
}

function callDisable(status) {
  if (sbUserId.substring(0, 1) == 'u') { // 유저만
    // $('.callBtn').attr('disabled', status);
    if (status == false) {
      $('.callBtn').show();
      $('.callBtnDisabled').hide();
    } else {
      $('.callBtn').hide();
      $('.callBtnDisabled').show();
    }
  }
}

function checkInMeeting() {
  let now = moment().format('YYYY-MM-DD HH:mm');
  console.log(meetingStart + " --- " + now);
  if (meetingStart <= now && meetingEnd >= now) {
    console.log('inTime');
    // inputDisable(false);
    callDisable(false);
    if (now == moment(meetingStart).add(15, 'm').format('YYYY-MM-DD HH:mm')) {
      alert('상담 종료 5분전입니다.');
    }
    setTimeout(() => {
      checkInMeeting();
    }, 1000 * 60);
    
  } else if (meetingStart > now) {
    console.log('waiting...');
    setTimeout(() => {
      checkInMeeting();
    }, 1000 * 60);
  } else {
    // inputDisable(true);
    callDisable(true);
    inMeetingTime = false;
    console.log('timeOver');
  }
}
